import React, { useEffect, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { url } from '../configlink'

const Unsubscribe = () => {

    const loc = useLocation()
    let [data, setData] = useState({})
    
    useEffect(() => {
        if(loc.search){
            let email = loc.search.split('=')[1]

            setData({
                email: email,
            })            
        }     
          
    }, [])

    // const urlParams = new URLSearchParams(window.location.search);
    // const token = urlParams.get("token");

    // let data = {}

    let [closeWindow, setCloseWindow] = useState(false)

    function doAction(){
        
        // console.log(data);
        
        try {
            fetch(`${url}/api/profile/emailPreferences`, {
              method: "POST",
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json',
                //  Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify(data)
            })
            .then(res => res.json())
            .then(data => {
              console.log(data); 
              if(data.message === 'success'){
                // alert("Success")
                setCloseWindow(true)
              }
              
            }).catch(error => {
              console.error('There was a problem with the update operation:', error);
    
            })
          } 
          catch(err) {
            console.error(err);
          }
        
        
    }

  return (
    <div className=''>
        <div className='flex justify-center'>
            <NavLink to='https://acgtinc.com/'
            target="_blank"
            >
                <img
                  className='w-[250px] h-auto my-4'
                  src='/images/acgt-logo-2022.png'
                  alt='acgt-logo'
                />
            </NavLink>
                </div>
                <div className='border-2 border-[var(--color-primary-purple)] bg-[var(--color-primary-purple)] h-[30px]  '></div>
        
        {closeWindow ? 
        <div className='flex items-center justify-center p-8 mt-36'>
          <p className='text-2xl font-bold text-blue-600'>Success. Please close this tab.</p>
        </div>
          :
          <div className='flex items-center justify-center p-8 mt-36'>
          <div className='border-2 border-[var(--color-primary-purple)] rounded-md flex flex-col items-center justify-center p-4 gap-[30px] max-w-[600px]'>
              <p className='text-lg sm:text-xl text-center'>Are you sure you want to Unsubscribe from Newsletter?</p>
              <div className='flex gap-[30px]'>
                  <button onClick={() => doAction()} className={`px-4 py-2 rounded-3xl font-bold bg-[var(--color-primary-purple)] w-[120px] sm:w-[200px] self-center text-white uppercase mb-4`}>Yes</button>
                  {/* <button onClick={() => window.close()} className={`px-4 py-2 rounded-3xl font-bold bg-gray-200 w-[120px] sm:w-[200px] self-center text-[var(--color-primary-purple)] uppercase mb-4 mt-6`}>No</button> */}
              </div>
          </div>
      </div>
        }
       
    </div>
  )
}

export default Unsubscribe